import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import MinusCircle from '../assets/svg/minusCircle.svg';
import { theme } from '../styles';

const List = ({ items }) => (
  <ListWrapper>
    {items.map((item, ind) => (
      <ListItem
        key={`list-item-${ind}`}
        initial={theme.fadeIn.initial}
        animate={theme.fadeIn.animate}
        transition={theme.fadeIn.transition(theme.delaySm + 0.1 * ind)}
      >
        {item}
      </ListItem>
    ))}
  </ListWrapper>
);

export const ListWrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
`;

export const ListItem = styled(motion.li)`
  margin: 0;
  padding-left: 1.75em;

  letter-spacing: ${props => props.theme.normalSpacing};
  color: ${props => props.theme.textColor};

  verticle-align: middle;

  list-style: none;
  background: url(${MinusCircle}) no-repeat left top;
  background-size: 1.25em;
`;

export default List;
